// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"612":"f1818a99","854":"e7e3a2da"}[chunkId] + ".chunk.js";
};